export default __webpack_public_path__ + "static/media/3-cassettes-open-2-left.a9ee8d4c.svg";